/**
 * 简化版拼音首字母提取
 * 覆盖管理后台菜单中常用的中文字符
 */
const pinyinMap = {
  // 核心业务
  '仪': 'y', '表': 'b', '板': 'b', '设': 's', '备': 'b', '管': 'g', '理': 'l',
  '家': 'j', '庭': 't', '核': 'h', '心': 'x', '业': 'y', '务': 'w',
  
  // 用户运营
  '人': 'r', '员': 'y', '会': 'h', '邀': 'y', '请': 'q', '用': 'y', '户': 'h',
  '运': 'y', '营': 'y',
  
  // 交易管理
  '支': 'z', '付': 'f', '套': 't', '餐': 'c', '兑': 'd', '换': 'h', '码': 'm',
  '交': 'j', '易': 'y', '概': 'g', '览': 'l', '订': 'd', '单': 'd', '退': 't',
  '款': 'k', '批': 'p', '次': 'c', '列': 'l',
  
  // 内容管理
  '内': 'n', '容': 'r', '协': 'x', '议': 'y', '通': 't', '知': 'z',
  
  // 系统配置
  '短': 'd', '信': 'x', '版': 'b', '本': 'b', '商': 's', '店': 'd', '配': 'p',
  '置': 'z', '功': 'g', '能': 'n', '权': 'q', '限': 'x', '系': 'x', '统': 't',
  
  // 平台服务
  '中': 'z', '台': 't', '开': 'k', '发': 'f', '者': 'z', '工': 'g', '具': 'j',
  '反': 'f', '馈': 'k', '平': 'p', '服': 'f',
  
  // 会员相关
  '额': 'e', '阅': 'y', '计': 'j', '记': 'j', '录': 'l', '奖': 'j', '励': 'l',
  '规': 'g', '则': 'z', '定': 'd', '价': 'j', '量': 'l', '对': 'd', '账': 'z',
};

/**
 * 获取中文字符串的拼音首字母
 * @param {string} str - 中文字符串
 * @returns {string} - 拼音首字母字符串
 */
export const toPinyin = (str) => {
  if (!str) return '';
  return str
    .split('')
    .map(char => pinyinMap[char] || char)
    .join('');
};

export default toPinyin;
